<template>
    <div class="add-work-email">
        <div class="content">
            <div class="data-title">
                <div class="title-name">新增公告内容</div>
            </div>
            <div class="text">基本信息</div>
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small"
                    label-width="96px" autocomplete="off">
                    <el-form-item label="标题:" prop="title">
                        <el-input v-model="form.title" placeholder="请输入" maxlength="50" clearable
                            show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item label="选择分类:" prop="category" class="add-category">
                        <div class="category-container">
                            <el-select v-model="form.category" placeholder="请选择"
                                style="width: 100%;margin-right: 16px;">
                                <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <div class="add-category-btn" style="cursor: pointer;" @click="showAddCategoryDialog">
                                <img src="@/assets/img/announcement/add.png"
                                    style="width: 10px; height: 10px; margin-right: 4px;">
                                <span>新建分类</span>
                            </div>
                        </div>

                    </el-form-item>

                    <el-form-item label="作者:" class="t-label">
                        <el-input v-model="form.author" placeholder="请输入" clearable maxlength="256" rows="3"
                            show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="接收人员:" prop="receivers">
                        <div class="category-container">
                            <el-select v-model="form.receivers" placeholder="请选择接收人员" @click.native="openUserPicker"
                                class="select-u" collapse-tags size="medium" multiple popper-class="hidden"
                                style="margin-right: 16px;width: 100%;">
                                <el-option v-for="(user, index) in form.receivers" :key="index" :label="user.name"
                                    :value="user">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="正文:" prop="content" style="display: flex;">
                        <template #label>
                            <div style="width: 88px;">正文:</div>
                        </template>
                        <div style="border: 1px solid #ccc;width: 104vh;position: relative;">
                            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
                                :defaultConfig="toolbarConfig" :mode="mode" />
                            <Editor style="height: 500px; overflow-y: hidden;" v-model="html"
                                :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated"
                                @onChange="onEditorChange" />
                            <!-- 添加字数统计显示 -->
                            <div class="word-count">{{ wordCount }}/10000</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="附件:" prop="attachmentList" style="display: flex;">
                        <div style="width: 100%;">
                            <attachment-upload v-model="form.attachmentList"></attachment-upload>
                        </div>
                    </el-form-item>

                </el-form>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info" plain @click="back">返回</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
                <el-button type="primary" plain @click="preview">预览</el-button>
                <el-button type="primary" @click="save" :loading="btnSave">保存草稿</el-button>
                <el-button type="primary" @click="submit" :loading="btnSubmit">提交</el-button>
            </div>

            <!-- 新建分类弹窗 -->
            <el-dialog class="add-category-dialog" :visible.sync="addCategoryDialogVisible" width="520px" :modal="true"
                :append-to-body="true">
                <el-form :model="newCategoryForm" ref="newCategoryForm">
                    <el-form-item label="分类名" prop="name">
                        <template #label>
                            <div class="dialog-title" style="text-align: left;">分类名 <br />
                                <span>新建分类默认排在最后，可在分类列表中调整显示排序</span>
                            </div>
                        </template>
                        <el-input v-model="newCategoryForm.name" placeholder="请输入名称(限10个字符)" maxlength="10"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addCategoryDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="addCategory">确定</el-button>
                </span>
            </el-dialog>
            <!-- 公告预览弹窗 -->
            <el-dialog class="preview-dialog" :append-to-body="true" :visible.sync="previewDialogVisible"
                width="800px" title="公告预览" :modal="true">
                <div class="preview-content">
                    <div class="preview-title">
                        <span>{{ previewData.title || '无标题' }}</span>
                    </div>

                    <div class="preview-meta">
                        <div class="meta-item" v-if="previewData.categoryName || previewData.author">
                            <span class="meta-value">{{ (previewData.author || '')
                                }}</span>
                            <span style="padding: 0 10px;">|</span>
                            <span style="color: #409EFF;">
                                {{ '#' + (previewData.categoryName || '') + '#' }}
                            </span>
                        </div>
                        <div class="meta-item">
                            <span>{{ currentTime }}</span>
                        </div>
                    </div>

                    <div class="preview-body">
                        <div class="preview-html" v-html="previewData.content"></div>
                    </div>

                    <div class="preview-attachments" v-if="previewData.attachments && previewData.attachments.length">
                        <h3>附件</h3>
                        <ul class="attachment-list">
                            <li v-for="(file, index) in previewData.attachments" :key="index" class="attachment-item">
                                <img class="el-icon-document" src="@/assets/img/announcement/fujian.png" alt="">
                                <div class="file-info">
                                    <span class="file-name" :title="file.name">{{ file.name }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="previewDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>
        </div>
        <org-picker title="接收人员" :multiple="true" ref="orgPicker" @ok="selectedUser" />
    </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import OrgPicker from "@/components/OrgPicker";
import AttachmentUpload from "@/pages/announcement/components/AttachmentUpload.vue";
import * as qiniu from 'qiniu-js';

export default {
    name: 'annoucementAdd',
    components: {  Editor, Toolbar, OrgPicker, AttachmentUpload },
    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        // 自定义校验图片函数
        const customCheckImageFn = (src, alt, url) => {
            if (!src) {
                return;
            }
            if (src.indexOf('http') !== 0 && src.indexOf('data:image') !== 0) {
                return '图片网址必须以 http/https 开头或为有效的base64数据';
            }
            return true;
        };

        // 转换图片链接
        const customParseImageSrc = (src) => {
            if (src.indexOf('http') !== 0 && src.indexOf('data:image') !== 0) {
                return `http://${src}`;
            }
            return src;
        };
        return {

            wordCount: 0,// 添加字数统计变量
            editor: null,
            html: '',

            toolbarConfig: {
                excludeKeys: [
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                // 启用粘贴图片功能
                pasteIgnoreImg: false,
                // 配置菜单栏，添加上传图片功能
                MENU_CONF: {
                    uploadImage: {
                        customUpload: this.uploadImage, //自定义上传
                        maxFileSize: 10 * 1024 * 1024, // 10M
                        allowedFileTypes: ['image/*'],
                        // 添加base64上传支持
                        base64Upload: true,
                        base64LimitSize: 5 * 1024, // 5kb以下的图片转为base64
                        onInsertedImage: this.onInsertedImage, // 图片插入成功回调
                        onUpdatedImage: this.onUpdatedImage, // 图片更新成功回调
                        checkImage: customCheckImageFn, // 自定义图片校验函数
                        parseImageSrc: customParseImageSrc, // 自定义图片链接转换函数
                    },
                    //插入图片配置
                    insertImage: {
                        onInsertedImage: this.onInsertedImage,
                        checkImage: customCheckImageFn,
                        parseImageSrc: customParseImageSrc
                    },
                    //编辑图片配置
                    editImage: {
                        onUpdatedImage: this.onUpdatedImage,
                        checkImage: customCheckImageFn,
                        parseImageSrc: customParseImageSrc
                    }
                }
            },
            mode: 'default',
            form: {
                title: '',
                category: '',
                author: '',
                receivers: [],
                attachmentList: [],
                // 更多信息字段
                createdTime: '',
                createdByName: '',
                approvalStatus: '',
                noticeStatus: '',
                updatedTime: '',
                updatedByName: '',
                publishTime: '',
                sendCount: 0,
                readCount: 0,
                confirmCount: 0,
                unreadCount: 0
            },

            categoryList: [],
            addCategoryDialogVisible: false,
            previewDialogVisible: false, // 控制预览对话框显示
            previewData: {}, // 预览数据
            currentTime: new Date().toLocaleString(), // 当前时间，用于模拟发布时间
            newCategoryForm: {
                name: ''
            },
            btnSave: false,
            btnSubmit: false,
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                category: [
                    { required: true, message: '请选择分类', trigger: 'change' }
                ],
                receivers: [
                    { required: true, message: '请输入接收人员', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        // 初始化页面数据
        this.initPage();
    },
    activated() {
        // 确保每次进入页面时都是全新状态
        this.resetForm();
    },
    beforeDestroy() {
        const editor = this.editor;
        if (editor == null) return;
        editor.destroy();
    },
    methods: {
        // 初始化页面
        initPage() {
            // 重置表单数据
            this.resetForm();


            // 获取分类列表
            this.fetchCategories();
        },

        // 重置表单数据
        resetForm() {
            this.form = {
                title: '',
                category: '',
                author: '',
                receivers: [],
                attachmentList: [],
                // 更多信息字段
                createdTime: '',
                createdByName: '',
                approvalStatus: '',
                noticeStatus: '',
                updatedTime: '',
                updatedByName: '',
                publishTime: '',
                sendCount: 0,
                readCount: 0,
                confirmCount: 0,
                unreadCount: 0
            };
            this.html = '';
            this.addCategoryDialogVisible = false;
            this.newCategoryForm.name = '';
            this.btnSave = false;
            this.btnSubmit = false;

            // 重置表单验证
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },

        formatFileSize(size) {
            if (size < 1024) {
                return size + 'B';
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + 'KB';
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + 'MB';
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
            }
        },

        // 时间格式化方法
        formatDateTime(dateTime) {
            if (!dateTime || dateTime === '-') return '-';

            try {
                // 解析ISO格式时间
                const date = new Date(dateTime);

                // 检查日期是否有效
                if (isNaN(date.getTime())) return dateTime;

                // 格式化为 YYYY-MM-DD HH:mm:ss
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式转换错误:', error);
                return dateTime;
            }
        },

        fetchCategories() {
            return this.$api.announcementCList().then(res => {
                if (res.code == 0) {
                    this.categoryList = res.data.map(item => {
                        return {
                            id: item.id,
                            categoryName: item.categoryName,
                            editing: false,
                            tempName: "",
                        }
                    });
                    return this.categoryList; // 返回分类列表
                }
            }).catch(error => {
                console.error('获取分类列表失败:', error);
                this.$message.error('获取分类列表失败');
                return [];
            });
        },

        // 显示新建分类弹窗
        showAddCategoryDialog() {
            this.newCategoryForm.name = '';
            this.addCategoryDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.newCategoryForm) {
                    this.$refs.newCategoryForm.clearValidate();
                }
            });
        },

        // 修改后的添加分类方法
        addCategory() {
            this.$refs.newCategoryForm.validate((valid) => {
                if (valid) {
                    // 调用API添加分类
                    this.$api.announcementCAdd({ categoryName: this.newCategoryForm.name }).then(res => {
                        if (res.code === 0) {
                            this.$message.success('分类添加成功');
                            this.addCategoryDialogVisible = false;

                            // 刷新分类列表
                            this.fetchCategories().then(categoryList => {
                                // 查找新添加的分类（通过名称匹配）
                                const newCategory = categoryList.find(
                                    cat => cat.categoryName === this.newCategoryForm.name
                                );

                                if (newCategory) {
                                    // 设置新添加的分类为选中状态
                                    this.form.category = newCategory.id;
                                } else {
                                    console.warn('未能找到新添加的分类');
                                }
                            });
                        } else {
                            this.$message.error(res.msg || '添加分类失败');
                        }
                    }).catch(err => {
                        console.error('添加分类失败:', err);
                        // 这里不再显示错误消息，避免重复提示
                    });
                }
            });
        },

        // 预览方法 - 修改为使用当前表单数据
        preview() {
            // 验证表单必填项
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 收集预览数据 - 使用当前表单数据
                    const category = this.categoryList.find(item => item.id === this.form.category);

                    this.previewData = {
                        title: this.form.title,
                        categoryName: category ? category.categoryName : '',
                        author: this.form.author,
                        receivers: this.form.receivers,
                        content: this.html,
                        attachments: this.form.attachmentList.filter(file => file.status === 'success').map(file => ({
                            name: file.name,
                            url: file.url,
                            size: file.size,
                            type: file.type
                        }))
                    };

                    // 显示预览对话框
                    this.previewDialogVisible = true;
                } else {
                    this.$message.warning('请填写必填项后再预览');
                    return false;
                }
            });
        },

        //导出名单
        exportReadList() {
            this.$api.announcementReadExport({ id: this.$route.query.id }).then(res => {
                if (res.code == 0) {
                    const link = document.createElement("a");
                    link.href = res.data;
                    link.download = "公告阅读名单.xls";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.$message.success('导出成功')
                } else {
                    this.$message.error(res.message || '导出失败')
                }
            }).catch(err => {
                console.log(err)
                this.$message.error('导出失败')
            })
        },

        // 添加编辑器变化监听
        onEditorChange(editor) {
            // 处理编辑器内容变化
            console.log('editor change', editor);
            // 更新字数统计
            this.updateWordCount(editor);
        },

        // 修改上传图片方法，使用七牛云上传
        async uploadImage(file, insertFn) {
            // 如果是base64格式的图片
            if (typeof file === 'string' && file.startsWith('data:image')) {
                // 处理base64图片
                await this.uploadBase64ImageToQiniu(file, insertFn);
                return;
            }

            // 普通文件上传到七牛云
            await this.uploadFileToQiniu(file, insertFn);
        },


        // 上传文件到七牛云
        async uploadFileToQiniu(file, insertFn) {
            try {
                // 获取七牛云token
                const qiniuToken = await this.getQiniuToken();
                if (!qiniuToken) {
                    throw new Error('获取七牛云token失败');
                }

                // 生成唯一key
                const key = `announcement/images/${Date.now()}_${Math.random().toString(36).substr(2)}_${file.name}`;

                // 七牛云配置
                const config = {
                    useCdnDomain: true,
                    region: qiniu.region.z0 // 根据你的存储区域修改
                };

                const putExtra = {
                    fname: file.name,
                    params: {},
                    mimeType: null
                };

                // 创建上传观察对象
                const observable = qiniu.upload(
                    file,
                    key,
                    qiniuToken,
                    putExtra,
                    config
                );

                // 订阅上传进度
                const subscription = observable.subscribe({
                    next: (response) => {
                        // 可以在这里显示上传进度
                        console.log('上传进度:', parseInt(response.total.percent) + '%');
                    },
                    error: (err) => {
                        console.error('图片上传失败', err);
                        this.$message.error('图片上传失败');

                        // 上传失败时，如果是文件，尝试使用base64格式
                        if (file instanceof File) {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                insertFn(e.target.result, '', '');
                                this.$message.warning('图片上传失败，已使用base64格式插入');
                            };
                            reader.readAsDataURL(file);
                        }
                    },
                    complete: (response) => {
                        // 上传成功，获取文件URL
                        const url = 'https://fenxiao.muruji.com/' + response.key;
                        console.log('图片上传成功', url);
                        insertFn(url, '', '');
                        this.$message.success('图片上传成功');
                    }
                });

            } catch (error) {
                console.error('图片上传失败:', error);
                this.$message.error('图片上传失败');

                // 上传失败时，如果是文件，尝试使用base64格式
                if (file instanceof File) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        insertFn(e.target.result, '', '');
                        this.$message.warning('图片上传失败，已使用base64格式插入');
                    };
                    reader.readAsDataURL(file);
                }
            }
        },

        // 处理base64图片上传到七牛云
        async uploadBase64ImageToQiniu(base64, insertFn) {
            try {
                // 将base64转换为blob
                const blob = this.dataURLtoBlob(base64);

                // 生成文件名
                const fileName = `pasted-image-${Date.now()}.png`;

                // 创建File对象
                const file = new File([blob], fileName, { type: 'image/png' });

                // 使用七牛云上传
                await this.uploadFileToQiniu(file, insertFn);

            } catch (error) {
                console.error('base64图片上传失败:', error);
                this.$message.error('图片上传失败');
                // 上传失败，直接插入base64（不推荐，但作为备选方案）
                insertFn(base64, '', '');
                this.$message.warning('图片上传失败，已使用base64格式插入');
            }
        },

        // 获取七牛云token
        async getQiniuToken() {
            try {
                const res = await this.$api.qiniuToken();
                if (res.code === 0) {
                    return res.data;
                } else {
                    this.$message.error('获取上传凭证失败');
                    return null;
                }
            } catch (error) {
                this.$message.error('获取上传凭证失败');
                return null;
            }
        },

        // 简化的粘贴处理方法
        handlePaste(editor, event) {
            console.log('handlePaste triggered', editor);
            const clipboardData = event.clipboardData;

            let hasImage = false;
            let hasBase64Image = false;

            // 检查是否有图片文件
            const items = clipboardData.items;
            if (items) {
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.kind === 'file' && item.type.indexOf('image') !== -1) {
                        event.preventDefault();
                        const blob = item.getAsFile();
                        hasImage = true;

                        // 直接上传图片到七牛云
                        this.uploadImage(blob, (url, alt, href) => {
                            // 使用新的图片插入方法
                            this.insertImageToEditor(editor, url, alt || '粘贴的图片');
                        });
                        break;
                    }
                }
            }

            // 检查HTML内容中的base64图片（无论是否有文件图片都要检查）
            const html = clipboardData.getData('text/html');
            if (html && html.indexOf('<img') !== -1) {
                const base64Images = this.extractBase64Images(html);
                if (base64Images.length > 0) {
                    if (!hasImage) {
                        event.preventDefault();
                    }
                    hasBase64Image = true;

                    // 处理所有找到的base64图片
                    base64Images.forEach(base64Data => {
                        this.uploadImage(base64Data, (url, alt, href) => {
                            // 使用新的图片插入方法
                            this.insertImageToEditor(editor, url, alt || '粘贴的图片');
                        });
                    });
                }
            }

            // 如果既没有文件图片也没有base64图片，但包含其他HTML内容，允许默认粘贴行为
            if (!hasImage && !hasBase64Image && html) {
                // 允许默认的HTML粘贴行为
                return;
            }
        },

        // 将base64转换为Blob对象
        dataURLtoBlob(dataurl) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },

        // 插入图片后的回调
        onInsertedImage(imageNode) {
            if (imageNode == null) return;
            const { src, alt, url, href } = imageNode;
            console.log('inserted image', src, alt, url, href);
        },

        // 更新图片后的回调
        onUpdatedImage(imageNode) {
            if (imageNode == null) return;
            const { src, alt, url } = imageNode;
            console.log('updated image', src, alt, url);
        },

        onCreated(editor) {
            this.editor = Object.seal(editor);
            console.log('Editor created', editor);

            // 初始化字数统计
            this.updateWordCount(editor);

            // 监听内容变化，更新字数
            if (editor && editor.config) {
                editor.config.onChange = (editor) => {
                    console.log('Editor content changed');
                    this.updateWordCount(editor);
                };
            }

            // 绑定粘贴事件
            const editorDom = editor.getEditableContainer();
            if (editorDom) {
                editorDom.addEventListener('paste', (event) => {
                    this.handlePaste(editor, event);
                });
            }
        },

        // 字数统计方法
        updateWordCount(editor) {
            if (!editor) return;

            //获取纯文本内容并计算字数 
            const text = editor.getText();
            //去除首尾空格并计算字数
            const count = text.trim() ? text.trim().length : 0;
            this.wordCount = count;

            //如果超过限制，撤销最后一次操作
            if (count > 10000) {
                this.$message.warning('公告内容不能超过10000字，请修改后重新提交！');
                editor.undo();
                //重新计算字数
                const newText = editor.getText().trim();
                this.wordCount = newText ? newText.length : 0;
            }
        },


        // 插入图片到编辑器
        insertImageToEditor(editor, src, alt = '') {
            // 使用 dangerouslyInsertHtml 方法插入图片
            const imgHtml = `<img src="${src}" alt="${alt}" style="max-width: 100%; height: auto; display: block; margin: 10px 0;" />`;
            editor.dangerouslyInsertHtml(imgHtml);
        },

        // 添加提取base64图片的方法
        extractBase64Images(html) {
            const base64Images = [];
            const imgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
            let match;

            while ((match = imgRegex.exec(html)) !== null) {
                if (match[1]) {
                    base64Images.push(match[1]);
                }
            }

            return base64Images;
        },

        //打开人员选择器
        openUserPicker() {
            this.$refs.orgPicker.show(this.form.receivers);
        },

        //人员选择回调
        selectedUser(data) {
            this.form.receivers = data;
        },

        back() {
            this.$router.go(-1)
        },

        reset() {
            this.form = {
                title: '',
                category: '',
                author: '',
                receivers: [],
                attachmentList: [],
                // 更多信息字段
                createdTime: '',
                createdByName: '',
                approvalStatus: '',
                noticeStatus: '',
                updatedTime: '',
                updatedByName: '',
                publishTime: '',
                sendCount: 0,
                readCount: 0,
                confirmCount: 0,
                unreadCount: 0
            };
            this.html = '';
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },

        // 保存
        save() {
            {
                    this.btnSave = true;

                    // 构建保存数据
                    const saveData = {
                        title: this.form.title,
                        categoryId: this.form.category,
                        author: this.form.author,
                        receiveList: this.form.receivers,
                        content: this.html,
                        attachmentList: this.form.attachmentList.filter(file => file.status === 'success').map(file => ({
                            name: file.name,
                            url: file.url,
                            size: file.size,
                            type: file.type
                        }))
                    };
                    this.$api.announcementSave(saveData).then(res => {
                        this.btnSave = false;
                        if (res.code === 0) {
                            this.$message({
                                message: '草稿已保存',
                                type: 'success'
                            });
                            // 通知列表页刷新数据
                            this.$bus.$emit('refreshAnnouncementList');
                            this.back();
                        } else {
                            this.$message.error(res.msg || ('保存失败'));
                        }
                    }).catch(err => {
                        this.btnSave = false;
                        this.$message.error('保存失败');
                    });
            }
        },
        //提交
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSubmit = true;

                    // 构建保存数据
                    const saveData = {
                        title: this.form.title,
                        categoryId: this.form.category,
                        author: this.form.author,
                        receiveList: this.form.receivers,
                        content: this.html,


                        attachmentList: this.form.attachmentList.filter(file => file.status === 'success').map(file => ({
                            name: file.name,
                            url: file.url,
                            size: file.size,
                            type: file.type
                        }))
                    };

                    this.$api.announcementSubmit(saveData).then(res => {
                        this.btnSubmit = false;
                        if (res.code === 0) {
                            this.$message({
                                message: '公告提交成功',
                                type: 'success'
                            });
                            // 通知列表页刷新数据
                            this.$bus.$emit('refreshAnnouncementList');
                            this.back();
                        } else {
                            this.$message.error(res.msg || ('提交失败'));
                        }
                    }).catch(err => {
                        this.btnSubmit = false;
                        this.$message.error('提交失败');
                    });
                }
            });
        },

    }
}
</script>
<style lang="scss" src="@/pages/announcement/common/style/add.scss" scoped />
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
// 预览对话框样式
.preview-dialog {
    .preview-content {
        padding: 0 20px;
        max-height: 70vh;
        overflow-y: auto;

        .preview-title {
            text-align: left;
            margin-bottom: 20px;
            font-weight: bold;
            font-size: 24px;
            color: #1E1E1E;
            padding-bottom: 8px;
        }

        .preview-meta {
            margin-bottom: 20px;
            padding-bottom: 15px;

            .meta-item {
                display: flex;
                margin-bottom: 8px;
                font-weight: 500;
                font-size: 12px;

                .meta-value {
                    font-weight: 500;
                    font-size: 14px;
                    color: #1E1E1E;
                }
            }
        }

        .preview-body {
            margin-bottom: 20px;

            ::v-deep .preview-html {
                line-height: 1.6;

                p {
                    margin-bottom: 1em;
                }

                img {
                    max-width: 100%;
                    height: auto;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;

                    th,
                    td {
                        border: 1px solid #ddd;
                        padding: 8px;
                    }

                    th {
                        background-color: #f5f5f5;
                    }
                }
            }
        }

        .preview-attachments {
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px solid #eee;

            h3 {
                margin-bottom: 12px;
                color: #333;
                font-size: 16px;
            }

            .attachment-list {
                display: flex;
                flex-wrap: wrap;
                gap: 15px;
                list-style: none;
                padding: 0;
                margin: 0;

                .attachment-item {
                    display: flex;
                    align-items: center;
                    width: 245px;
                    padding: 10px;
                    background-color: #f9f9f9;
                    border-radius: 4px;
                    border: 1px solid #eee;
                    cursor: pointer;
                    transition: background-color 0.2s;

                    &:hover {
                        background-color: #f0f0f0;
                    }

                    .el-icon-document {
                        width: 32px;
                        height: 32px;
                        margin-right: 8px;
                        flex-shrink: 0;
                    }

                    .file-info {
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        min-width: 0;
                    }

                    .file-name {
                        color: #333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        line-height: 1.4;
                        margin-bottom: 4px;
                    }

                    .file-size {
                        color: #999;
                        font-size: 12px;
                        flex-shrink: 0;
                    }
                }
            }
        }


    }

    // 对话框底部按钮
    ::v-deep .el-dialog__footer {
        text-align: center;
    }


}
</style>
